import React from 'react'
import {Route, Switch} from 'react-router-dom'
import {HomePage} from '../pages/Home'
import {NotFoundPage} from "../pages/NotFound";
import {AboutPage} from "../pages/About";
import {FAQPage} from "../pages/FAQ";
import {ImpressionPage} from "../pages/Impressum";
import {DownloadPage} from "../pages/Download";
import {InstallationPage} from "../pages/Installation";
import {WindowsDownloadPage} from "../pages/Download/windows";
import {LinuxDownloadPage} from "../pages/Download/linux";
import {MacDownloadPage} from "../pages/Download/mac";
import {ApkDownloadPage} from "../pages/Download/apk";
import {BusinessPage} from "../pages/Business";
import {BusinessFAQPage} from "../pages/Business/FAQ";
import {BusinessAboutPage} from "../pages/Business/About";
import {BusinessFunctionalPage} from "../pages/Business/Functional";

export const Routing = () => {
    return (
        <Switch>
            <Route exact path="/" component={HomePage}/>
            <Route path="/about" component={AboutPage}/>
            <Route path="/faq" component={FAQPage}/>
            <Route path="/download/windows" component={WindowsDownloadPage}/>
            <Route path="/download/linux" component={LinuxDownloadPage}/>
            <Route path="/download/mac" component={MacDownloadPage}/>
            <Route path="/download/apk" component={ApkDownloadPage}/>
            <Route path="/download/:device" component={InstallationPage}/>
            <Route path="/download" component={DownloadPage}/>
            <Route path="/impression" component={ImpressionPage}/>
            <Route path="/business/about" component={BusinessAboutPage}/>
            <Route path="/business/faq" component={BusinessFAQPage}/>
            <Route path="/business/functional" component={BusinessFunctionalPage}/>
            <Route path="/business" component={BusinessPage}/>
            <Route component={NotFoundPage}/>
        </Switch>
    );
}
